import { Action, ThunkAction, configureStore } from '@reduxjs/toolkit'
import { api } from '@store/api'
import { authReducer } from '@store/auth/auth.slice'
import { globalReducer } from '@store/global/global.slice'

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer, //RTK Query
    global: globalReducer,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware),
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>
